import {PUSH_DATA_FROM_FORM} from "../constants/constants";

export const pushDataFromForm = (data) => {
      return{
          type : PUSH_DATA_FROM_FORM,
          payload: data
      };
};


// WEBPACK FOOTER //
// ./src/actions/pushDataFromForm.js